import type { ReactElement } from 'react';

import { PostsBlock } from '@/blocks/posts-block';
import { ContentMatrix } from '@/components/content-matrix';
import { AllPostsPostInterface, PostInterface } from '@/types/cms-types';

interface PostListingViewProps {
  posts: AllPostsPostInterface[];
  postType: PostInterface['postType'];
  totalPosts: number;
  currentPage: number;
  blocks?: any[];
  itemsPerPage?: number;
}

const POSTS_PER_PAGE = 12;

const PostListingView = ({
  posts,
  postType,
  totalPosts,
  currentPage,
  blocks,
  itemsPerPage = POSTS_PER_PAGE,
}: PostListingViewProps): ReactElement => {
  return (
    <>
      <ContentMatrix blocks={blocks} />

      <PostsBlock
        id="posts"
        posts={posts}
        postType={postType}
        currentPage={currentPage}
        totalPosts={totalPosts}
        itemsPerPage={itemsPerPage}
        showPagination
      />
    </>
  );
};

export { PostListingView };
